import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-center pt-4" }
const _hoisted_2 = { class: "bg-primary installation-modal-icon" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "QR-code installation")
], -1)
const _hoisted_4 = { class: "qr mt-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "sm mt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4 w-100" }, null, -1)
const _hoisted_8 = { class: "installation-modal-icon bg-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", { class: "mt-2 pb-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "QR-code installation")
], -1)
const _hoisted_10 = { class: "manual-installation-info mt-4" }
const _hoisted_11 = { class: "d-flex py-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", { class: "font-15 me-3 color-primary" }, [
  /*#__PURE__*/_createElementVNode("b", null, "SM-DP+Address: ")
], -1)
const _hoisted_13 = { class: "sm" }
const _hoisted_14 = { class: "d-flex py-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", { class: "font-15 me-3 color-primary" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Activation code: ")
], -1)
const _hoisted_16 = { class: "sm" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = { class: "d-flex w-100 justify-content-end page-heading-toolbar" }
const _hoisted_19 = { class: "page-heading-toolbar--col" }
const _hoisted_20 = { class: "page-heading-toolbar--col" }
const _hoisted_21 = { class: "profiles-wrapper" }
const _hoisted_22 = {
  key: 0,
  class: "profiles-preloader"
}
const _hoisted_23 = { class: "slot-details" }
const _hoisted_24 = { class: "slot-details--body" }
const _hoisted_25 = { class: "slot-details--body__table mb-5" }

import {
  computed,
  ComputedRef,
  nextTick,
  reactive,
  Ref,
  ref,
  watch
} from "vue";
import { useBaseAppLayout } from "@/hooks/layout/useBaseAppLayout";
import PageMainHeading from "@/components/Layout/PageMainHeading.vue";
import SelectDropdown from "../../../components/ui/Dropdown/SelectDropdown.vue";
import AppButton from "@/components/ui/Buttons/AppButton.vue";
import BtnContent from "../../../components/ui/Buttons/BtnContent.vue";
import AppTableController from "../../../components/Table/ts/AppTableController.vue";
import AppTabsHead from "../../../components/AppTabs/AppTabsHead.vue";
import ProfileSlotDetails from "@/components/Packages/eSIM/Profiles/ProfileSlotDetails.vue";
import { getFullDate } from "@/utills/dateConverter";
import DragAndDrop from "@/components/ui/DragAndDrop.vue";
import Dialog from "@/components/ui/Modal/Dialog/Dialog.vue";
import AppTable from "@/components/Table/ts/AppTable.vue";
import AppPreloader from "@/components/ui/AppPreloader.vue";
import SvgIcon from "@/components/ui/SvgIcon.vue";
import {
  ITableBodyRow,
  ITableHeadCell
} from "@/components/Table/ts/interfaces/TableStructure";
import { sorting, useBaseTable } from "@/hooks/tables/useTable";
import { sortOrders } from "@/enums/main/sortOrders";
import { badgeSizes, badgeTypes } from "@/components/ui/AppBadge/interfaces";
import moment from "moment";
import {
  esimProfile,
  esimType,
  IEsimServerFull
} from "@/api/services/profiles/profiles.types";
import { api } from "@/api/Api";
import { useStore } from "vuex";

interface IActiveServer extends IEsimServerFull {
  updatedDate: string;
  uploadedDate: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ESIMProfiles',
  setup(__props) {

const store = useStore();

const START_YEAR = 2020;
const CURRENT_YEAR = new Date(Date.now()).getFullYear();

const initialViewConfiguration = { page: 1, perPage: 10 };
const loading = ref(true);
const uploadLoading = ref(false);
const modalLoading = ref(false);
const importModalOpened = ref(false);
const installationModalOpened = ref(false);
const installationTitle = ref("");

const uploadProgress = ref(0);
const uploadSuccess: Ref<boolean | null> = ref(null);
const uploadErrorMessage = ref("");

const profiles: Ref<esimProfile[]> = ref([]);
const totalProfiles = ref(0);

const yearsList = Array.from(
  {
    length: CURRENT_YEAR - START_YEAR + 1
  },
  (_, idx) => START_YEAR + idx
);

const qr = reactive({
  image: "",
  iccid: "",
  address: "",
  code: ""
});
const appRefs = useBaseAppLayout({
  filterOptions: ["All", ...yearsList.map(year => year.toString())],
  initialSelectedFilterOptionIdx: 0
});

const selectedYear = computed(() => {
  return appRefs.selectedFilterOption.value?.name || "All";
});

function hideImportModal() {
  if (uploadLoading.value) return;

  importModalOpened.value = false;
  uploadProgress.value = 0;
  uploadLoading.value = false;
  uploadErrorMessage.value = "";
  uploadSuccess.value = null;
}

async function importFile(table: File) {
  uploadProgress.value = 0;
  uploadSuccess.value = null;
  uploadErrorMessage.value = "";

  uploadLoading.value = true;
  console.log(table)
  // "data" not string when success
  const { data } = await api.importProfile(
    table,
    (progress: number) => {
      if (uploadProgress.value === 0) {
        if (progress === 100) {
          const interval = setInterval(() => {
            uploadProgress.value += 0.6;
            if (uploadProgress.value >= 90) {
              clearInterval(interval);
            }
          }, 15);

          return;
        }

        uploadProgress.value = progress;
        return;
      }

      progress < 99 && (uploadProgress.value = progress);
    }
  );

  uploadLoading.value = false;
  uploadProgress.value = 100;

  const isData = typeof data === "string";
  if (isData) {
    const msg = (data as unknown) as string;
    uploadErrorMessage.value = msg || "";
    uploadSuccess.value = false;
    return;
  }

  uploadSuccess.value = true;
  await fetchProfiles();
}

watch(
  () => importModalOpened.value,
  opened => {
    if (!opened) {
      uploadProgress.value = 0;
    }
  }
);

const sortConfiguration: sorting = {
  byStatus: {
    keyNameInModel: "numericActive",
    order: sortOrders.asc,
    keyName: "active"
  },

  byDateUsed: {
    keyName: "date",
    order: sortOrders.turnOff,
    keyNameInModel: "dateUsed"
  }
};
const tableRefs = useBaseTable({
  initialViewConfiguration: { page: 1, perPage: 10 },
  model: computed(() =>
    profiles.value.map(profile => {
      return { ...profile, numericActive: profile.active ? 1 : 0 };
    })
  ),
  initialSortOptions: { ...sortConfiguration },
  generateRows(profilesList: any[] = []): ITableBodyRow[] {
    if (!profilesList) {
      return [];
    }

    return profilesList.map(
      (profile): ITableBodyRow => {
        const { id, i_account: iAccount, active, ICCID } = profile;

        return {
          onClick: () => {
            openQrModal(id);
          },
          actions: [
            {
              text: "Show QR",
              onClick: () => {
                openQrModal(id);
              }
            }
          ],
          cells: [
            { label: id || "-" },
            { label: iAccount || "-" },
            {
              badge: {
                label: active ? "Free" : "Used",
                type: active ? badgeTypes.lightSecondary : badgeTypes.danger,
                size: badgeSizes.md
              }
            },
            {
              label: ICCID || "-"
            }
          ]
        };
      }
    );
  }
});

const rows = computed(() => tableRefs.rows.value);

const cells: ComputedRef<ITableHeadCell[]> = computed(() => {
  return [
    {
      id: "Id",
      label: "ID",
      size: "md"
    },
    {
      id: "i_account",
      label: "I Account",
      size: "md"
    },
    {
      id: "status",
      size: "md",
      label: "Status",
      sort: {
        keyName: tableRefs.currentSort.byStatus.keyName,
        order: tableRefs.currentSort.byStatus.order
      }
    },
    {
      id: "iccid",
      label: "ICCID",
      size: "lg",
      sort: {
        keyName: tableRefs.currentSort.byDateUsed.keyName,
        order: tableRefs.currentSort.byDateUsed.order
      }
    }
  ];
});
fetchProfiles();
watch(
  [() => appRefs.selectedFilterOption.value],
  () => {
    tableRefs.changeViewConfiguration({
      page: 1,
      perPage: tableRefs.viewConfiguration.perPage
    });
  },
  { deep: true }
);

watch(
  [() => tableRefs.viewConfiguration, () => selectedYear.value],
  () => {
    fetchProfiles();
  },
  { deep: true }
);

async function openQrModal(listId: number) {
  modalLoading.value = true;
  const profileTitle =
    profiles.value.find(profile => profile.listId === listId)?.userId || "-";
  installationTitle.value = `${profileTitle}/`;

  installationModalOpened.value = true;
  const { success, message, data } = await api.getEsimQr(listId);

  if (!success && message) {
    await store.dispatch("showErrorNotification", message);
  }
  if (data) {
    const { image, iccid, address, code } = data;
    qr.address = address;
    qr.code = code;
    qr.image = image;
    qr.iccid = iccid;
  }

  await nextTick(() => {
    modalLoading.value = false;
  });
}

async function fetchProfiles() {
  const view = tableRefs?.viewConfiguration || initialViewConfiguration;
  await store.dispatch("setAppLoading", true);

  const {
    success,
    message,
    data: { result: profilesList = [], total = 0 }
  } = await api.fetchEsimProfiles({
    ...view,
    year: selectedYear.value
  });
  console.log(profilesList);
  if (!success && message) {
    return await store.dispatch("showErrorNotification", message);
  }
  loading.value = false;
  await store.dispatch("setAppLoading", false);
  profiles.value = profilesList;
  totalProfiles.value = total ?? 0;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Dialog, {
      title: installationTitle.value,
      opened: installationModalOpened.value,
      "modal-loading": modalLoading.value,
      onHide: _cache[0] || (_cache[0] = ($event: any) => (installationModalOpened.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(SvgIcon, { icon: "qr" })
          ]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: qr.image,
              alt: ""
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("strong", _hoisted_6, _toDisplayString(qr.iccid), 1),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(SvgIcon, { icon: "manual" })
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("strong", _hoisted_13, _toDisplayString(qr.address), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("strong", _hoisted_16, _toDisplayString(qr.code), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "opened", "modal-loading"]),
    _createVNode(Dialog, {
      title: "Profile upload",
      opened: importModalOpened.value,
      "can-close": !uploadLoading.value,
      onHide: hideImportModal
    }, {
      default: _withCtx(() => [
        _createVNode(DragAndDrop, {
          accepted: ['XLS', 'XLSX'],
          loading: uploadLoading.value,
          progress: uploadProgress.value,
          "upload-success": uploadSuccess.value,
          "upload-error": uploadErrorMessage.value,
          onFileChanged: importFile
        }, null, 8, ["loading", "progress", "upload-success", "upload-error"])
      ]),
      _: 1
    }, 8, ["opened", "can-close"]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(PageMainHeading, { title: "Profiles" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(SelectDropdown, {
                list: _unref(appRefs).filter,
                icon: "calendar-2",
                "on-select": _unref(appRefs).onFilterSelect
              }, null, 8, ["list", "on-select"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(AppButton, {
                size: "xl",
                type: "secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (importModalOpened.value = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(BtnContent, {
                    icon: "plus",
                    label: "Import File"
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(AppPreloader)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(AppTableController, {
                "show-table": !!profiles.value.length,
                "empty-key": "profiles",
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(AppTable, {
                    "table-head": _unref(cells),
                    "table-body": _unref(rows),
                    "total-rows": totalProfiles.value,
                    "current-page": _unref(tableRefs).viewConfiguration.page,
                    "per-page": _unref(tableRefs).viewConfiguration.perPage,
                    "pagination-capture-key": "Profiles",
                    onChangeViewConfiguration: _unref(tableRefs).changeViewConfiguration,
                    onSort: _unref(tableRefs).changeSorting
                  }, null, 8, ["table-head", "table-body", "total-rows", "current-page", "per-page", "onChangeViewConfiguration", "onSort"])
                ]),
                _: 1
              }, 8, ["show-table"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})